<div>
  <div ng2FileDrop
       [uploader]="uploader"
        class="upload-box">
    <h5>
      Drop files here or <a  href="javascript:;" (click)="fileInput.click()"
                             matTooltip="Only CSV files smaller than 10MB are allowed"
                             matTooltipPosition="above"
                             matTooltipClass="text-center"
                             class="upload-button">
      click
    </a> to upload
      <input type="file"
             [accept]="acceptFileExtensions"
             #fileInput
             ng2FileSelect
             [uploader]="uploader"
             multiple class="d-none">
    </h5>
  </div>
  <div class="upload-guide">
    <h5 [innerHtml]="guide?.description"></h5>
    <ul>
      <li *ngFor="let item of guide?.list" [innerHtml]="item"></li>
    </ul>
    <a *ngIf="guide.sample" href="javascript:;" (click)="downloadSample()">Download sample CSV</a>
  </div>
  <mat-accordion>
    <mat-expansion-panel *ngFor="let file of files; let i = index">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{file.file.name | truncate:30}}
          <small>(<i class="fal fa-hand-point-up"></i> Preview)</small>
        </mat-panel-title>
        <mat-panel-description>
          <mat-checkbox matTooltip="Please check this if the first row in this file is header line"
                        matTooltipPosition="above"
                        matTooltipClass="text-center" [(ngModel)]="file.isHeader" (click)="$event.stopPropagation()"
                        class="mt-primary">
            Remove Header
          </mat-checkbox>
          <span class="icon-container"
                [ngClass]="{'text-danger': file.isError, hidden:!file.isError}"
                [matTooltip]="getFileErrorText(file)"
                matTooltipPosition="above"
                matTooltipClass="text-left pre-line">
            <i class="fal fa-exclamation-square"></i>
          </span>

          <span class="text-danger icon-container remove"
                (click)="onRemoveFile(file, i)"
                matTooltip="Remove file"
                matTooltipPosition="above"
                matTooltipClass="text-left pre-line">
            <i class="fal fa-trash-alt"></i>
          </span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div class="table-responsive data-table-wrapper">
        <table class="table table-condensed" aria-hidden="false">
          <thead>
          <tr>
            <th class="icon"></th>
            <th *ngFor="let col of columnDefs" [style.width]="col.width"> {{col.name}}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let item of file.items; let i = index" [ngClass]="{hidden:file.isHeader && i == 0}">
            <td class="icon">
                <span class="icon-container"
                      [ngClass]="{'text-warning':!item.isError && item.isWarning, 'text-danger':item.isError }"
                      [matTooltip]="getItemErrorText(item)"
                      matTooltipPosition="above"
                      matTooltipClass="text-left pre-line">
                  <i class="fal fa-exclamation-triangle"
                     [ngClass]="{'fa-exclamation-triangle':!item.isError && item.isWarning, 'fa-exclamation-square':item.isError }"></i>
                </span>
            </td>
            <ng-container *ngFor="let field of item.originalFields; let j = index">
              <td *ngIf="j < columnDefs.length">
                {{field}}
              </td>
            </ng-container>
          </tr>
          </tbody>
        </table>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
